import React from 'react';
import PropTypes from 'prop-types';
import { CmsEntities } from 'client/data/models/cms';
import { parseLinkMetadata } from 'site-modules/shared/utils/parse-content-metadata';
import { ScrollElement } from 'site-modules/shared/components/scroll-link/scroll-element';
import { VehicleCard } from './vehicle-card';

import './vehicle-section.scss';

export function VehicleSection({ entry, openVideoModal, isMobile }) {
  const anchorName = entry.metadata('anchorName').value();
  const cardTitle = entry.metadata('card-title').value();

  // video
  const videoEntry = entry.child('card-video');
  const videoId = videoEntry.metadata('youtube-videoid').value();
  const videoTitle = videoEntry.metadata('videoTitle').value();
  const videoTranscript = videoEntry.metadata('videoTranscript').value();
  const videoThumbnailUrl = videoEntry.metadata('thumbnailURL').value();
  const videoAspectRatio = videoEntry.metadata('aspectRatio').value();

  // vehicle title
  const vehicleTitleEntry = entry.child('vehicle-title');
  const vehicleLinkData = parseLinkMetadata(vehicleTitleEntry, 'vehicle');

  const vehicleContent = entry.child('vehicle-content').metadata('copyText').value();

  /**
   * buttons
   *  - "primaryButton" is referring to the "btn-primary" button
   *  - "secondaryButton" is referrer to the "btn-primary-outline" button
   * */
  const buttonsEntry = entry.child('card-buttons');
  const primaryButtonData = parseLinkMetadata(buttonsEntry, 'button2');
  const secondaryButtonData = parseLinkMetadata(buttonsEntry, 'button1');

  return (
    <ScrollElement id={anchorName} className="vehicle-section pos-r mb-1_5" data-tracking-parent="card-video">
      <h2 className="heading-3 mb-1_5">{cardTitle}</h2>
      <VehicleCard
        vehicleContent={vehicleContent}
        videoId={videoId}
        videoTitle={videoTitle}
        videoAspectRatio={videoAspectRatio}
        videoTranscript={videoTranscript}
        videoThumbnailUrl={videoThumbnailUrl}
        primaryButtonData={primaryButtonData}
        secondaryButtonData={secondaryButtonData}
        vehicleLinkData={vehicleLinkData}
        openVideoModal={openVideoModal}
        isMobile={isMobile}
      />
    </ScrollElement>
  );
}

VehicleSection.propTypes = {
  entry: CmsEntities.Content.isRequired,
  openVideoModal: PropTypes.func.isRequired,
  isMobile: PropTypes.bool,
};

VehicleSection.defaultProps = {
  isMobile: false,
};
